export default __webpack_public_path__ + "static/media/701.59002077.jpg";